export const MESSAGE_LIST_MESSAGES_ELEMENTS_WRAPPER_ID = 'ml-c';
